<template>
    <div>
        <!-- <a class="dropdown-item" v-b-modal="data.account_number + transaction">Bank Direct</a> -->
        <b-modal :id="transaction" size="lg" @hidden="resetModal" @ok="handleOk" @show="onShow()">
            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <div class="w-100 d-flex align-items-center justify-content-between">
                    <div class="w-100 d-flex align-items-center justify-content-between" style="padding-right: 1rem;">
                        <h6 :class="getClassForTransaction(transaction)" class="fw-bold mb-0">
                            {{ isUpdate? "Update "+transaction : transaction }}
                            <span class="ms-5"><i class="far fa-money-bill-alt"></i></span>
                        </h6>

                        <p class="mb-0 akkurate-green" v-if="data.mandate">
                            <Span class="fw-bold">Mandate: </Span> {{ getMandate }}
                        </p>
                    </div>
                    <b-button variant="white" @click="close()">
                        &times;
                    </b-button>
                </div>
            </template>
            <form ref="form" @submit.stop.prevent="handleSubmit">
                <div class="row">
                    <!-- PassPort Pic -->
                    <div class="col-md-4 text-center">
                        <b-form-group label-for="passport" class="mb-3">
                            <template #label>
                                <label class="akkurate-dark small" for="member">Passport picture</label>
                            </template>
                            <img :src="data.customer?.passport_pic_path" alt="Image" style="height: 150px" class="img-fluid text-center" />
                        </b-form-group>
                    </div>
                    <!-- Signature -->
                    <div class="col-md-4 text-center">
                        <b-form-group label-for="member" class="mb-3">
                            <template #label>
                                <label class="akkurate-dark small" for="member">Signature</label>
                            </template>
                            <img :src="data.customer?.signature_image_path" alt="Image" style="height: 150px" class="img-fluid text-center" />
                        </b-form-group>
                    </div>
                    <!-- Ghana card -->
                    <div class="col-md-4 text-center">
                        <b-form-group label-for="member" class="mb-3">
                            <template #label>
                                <label class="akkurate-dark small" for="member">Ghana Card</label>
                            </template>
                            <img :src="data.customer?.gh_card_front_path" alt="Image" style="height: 150px" class="img-fluid text-center" />
                        </b-form-group>
                    </div>

                    <div class="col-md-12" v-if="data.customer?.loans?.length > 0 || data.guarantors?.length > 0">
                        <b-form-group label-for="member" class="mb-3 px-2 text-danger home-box border border-danger bg-white akkurate-extra-small">
                            <template #label>
                                <label class="akkurate-danger small fw-bold" for="member">Alert</label>
                            </template>
                            <div class="d-flex" v-if="data.customer?.loans?.length > 0">
                                <p class="p-0 m-0 akkurate-danger me-1" style="text-wrap: nowrap; width: fit-content;">
                                    <font-awesome-icon style="width: 5px; height: 5px; align-self: center; margin-right: 5px;" :icon="['fas', 'circle']" class="akkurate-danger rounded-circle" />
                                    Loan(s):
                                </p>
                                <p class="p-0 m-0 akkurate-danger d-flex">
                                    <span class="fw-bold" style="padding-left: 0.5rem;" v-for="loan in data.customer?.loans">
                                        {{ loan.loan_product?.name }} - Balance -
                                        {{ institution?.currency_code }}
                                        {{ displayNumber(
                                            loan.principal_balance
                                        ) }},
                                    </span>
                                </p>
                            </div>
                            <div v-if="data.guarantors?.length > 0" class="d-flex">
                                <p class="p-0 m-0 mb-auto akkurate-danger me-1" style="text-wrap: nowrap;">
                                    <font-awesome-icon style="width: 5px; height: 5px; align-self: center; margin-right: 5px;" :icon="['fas', 'circle']" class="akkurate-danger rounded-circle" />
                                    Guarantor To:
                                </p>
                                <p class="p-0 flex-wrap m-0 akkurate-danger d-flex">
                                    <span class="fw-bold" style="padding-left: 0.5rem;" v-for="guarantor in data.guarantors">
                                        {{ guarantor.loan?.loan_number }} -
                                        {{ guarantor.loan?.customer?.first_name +
                                            " " + guarantor.loan?.customer?.middlename + " " +
                                            guarantor.loan?.customer?.last_name }} -
                                        {{ guarantor.loan?.loan_product?.name }},
                                    </span>
                                </p>
                            </div>

                            <p class="p-0 m-0 akkurate-danger d-flex"><font-awesome-icon style="width: 5px; height: 5px; align-self: center; margin-right: 5px;" :icon="['fas', 'circle']" class="akkurate-danger rounded-circle" />
                                Cash Collateral: <span class="fw-bold" style="padding-left: 0.5rem;">{{
                                    " " + institution?.currency_code +
                                    " " +
                                    displayNumber(
                                        getTotalCashCollateral()
                                    ) }}</span></p>
                        </b-form-group>
                    </div>
                    <div v-if="data.account_type?.apply_withdrawal_charges == 1 && transaction == 'Bank Direct Withdrawal'" class="col-12 col-md-12">
						<div class="akkurate-danger fst-italic small fw-bold text-center mb-3">
							Note : Withdrawal charge is applied to this account (GHS {{
								data.account_type?.withdrawal_charges_amount }})
						</div>
					</div>

                    <div class="col-md-6">
                        <b-form-group label-for="member" class="mb-3">
                            <template #label>
                                <label class="akkurate-dark small" for="member">Member</label>
                            </template>
                            <b-form-input id="member" v-model="getFullNameAndID" v-validate="{ required: true }" :state="validateState('member')" name="member" class="mt-2 field-container fields" type="text" disabled></b-form-input>
                            <b-form-invalid-feedback>
                                The Balance field is required
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label-for="account_number" class="mb-3">
                            <template #label>
                                <label class="akkurate-dark small" for="account_number">Account Number</label>
                            </template>
                            <b-form-input id="account_number" v-model="data.account_number" v-validate="{ required: false }" :state="validateState('account_number')" name="account_number" class="mt-2 field-container fields" type="text" disabled></b-form-input>
                            <b-form-invalid-feedback>
                                The Balance field is required
                            </b-form-invalid-feedback>
                            <!-- <errors v-if="form.errors.account_balance">
                                   {{ form.errors.account_balance[0] }}
                               </errors> -->
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label-for="teller" class="mb-3">
                            <template #label>
                                <label class="akkurate-dark small" for="teller">Teller</label>
                            </template>
                            <b-form-input id="teller" name="teller" class="mt-2 field-container fields" v-validate="{ required: true }" :state="validateState('teller')" type="text" v-model="getTeller" disabled></b-form-input>
                            <b-form-invalid-feedback>
                                The Balance field is required
                            </b-form-invalid-feedback>
                            <!-- <errors v-if="form.errors.account_balance">
                                   {{ form.errors.account_balance[0] }}
                               </errors> -->
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <label class="akkurate-dark small" for="trans_date">Transaction Date <star></star></label>
                        <b-form-group id="trans_date" label-for="trans_date">
                            <b-form-input class="mt-2 field-container fields" v-validate="{ required: true }" :state="validateState('trans_date')" name="trans_date" v-model="form.trans_date" :disabled="!edit_date_pemission && !isUpdate" type="date"></b-form-input>
                            <b-form-invalid-feedback>
                                The Trasaction Date field is required
                            </b-form-invalid-feedback>
                            <!-- <errors v-if="form.errors.date_of_birth">
                            {{ form.errors.date_of_birth[0] }}
                        </errors> -->
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label-for="amount" class="mb-3">
                            <template #label>
                                <label class="akkurate-dark small" for="amount">Amount <star></star></label>
                            </template>
                            <b-form-input id="amount" v-validate="{ required: true }" :state="validateState('amount')" name="amount" class="mt-2 field-container fields" type="text" v-model="form.trans_amount" placeholder="Enter Amount"></b-form-input>
                            <b-form-invalid-feedback>
                                The Amount field is required
                            </b-form-invalid-feedback>
                            <!-- <errors v-if="form.errors.account_balance">
                                   {{ form.errors.account_balance[0] }}
                               </errors> -->
                        </b-form-group>
                    </div>


                    <div class="col-12 col-md-6">
                        <b-form-group label-for="bank_current" class="mb-2">
                            <template #label>
                                <label class="akkurate-dark small" for="bank_current">Select Bank <star></star></label>
                            </template>
                            <multiselect class="mt-2 field-container" v-model="form.bank_current" :options="bank_current_options" placeholder="Select Bank Driect" selectLabel="" deselectLabel="" name="bank_current" label="name" :disabled="isUpdate">
                            </multiselect>
                            <b-form-invalid-feedback>
                                The Bank Direct field is required
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>

                    <div class="col-12 col-md-6">
                        <b-form-group label-for="textarea-lazy" class="mb-2">
                            <template #label>
                                <label class="akkurate-dark small" for="narration">Narration <star></star></label>
                            </template>
                            <b-form-textarea class="mt-2 fields" id="textarea-lazy" v-validate="{ required: true }" :state="validateState('narration')" name="narration" v-model="form.narration" placeholder="Enter Narration" :disabled="isUpdate"></b-form-textarea>
                            <b-form-invalid-feedback>
                                The Narration field is required
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-6" v-if="!isUpdate">
                        <label title="Add Attachment" style="border-radius: 0.2rem;" class="label m-0 text-white border-0 mt-5 akkurate-small akkurate-gray-btn">
                            <input type="file" @change="handleFileUpload" />
                            <span class="small text-white">
                                <i class="fas fa-paperclip"></i></span>
                        </label>
                    </div>
                </div>

                <hr style="margin: 0.25rem;" />
                <div class="row">
                    <div class="col-12 col-md-12 text-center">
                        
                        <div v-if="selectedFile">
                            <label class="akkurate-dark small">Preview</label>
                            <img class="imagePreviewWrapper" :src="previewUrl" alt="File Preview" />
                            <b-button type="button" @click="uploadFile" :disabled="upload_processing" class="akkurate-green-btn">
                                <b-spinner v-if="spin_visible" small></b-spinner>
                                <i v-if="success_visible" class="fas fa-check loading"></i>
                                <i v-if="text_visible" class="fas fa-upload loading"></i>
                                {{ upload }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </form>

            <template #modal-footer="{ ok }">
                <div class="w-100">
                    <!-- begin loader -->
                    <!-- <beat-loader-component 
               class="float-left"
               v-if="isLoading"
               :isLoading="isLoading"
               ></beat-loader-component> -->
                    <!-- end loader -->
                    <!-- Emulate built in modal footer ok and cancel button actions -->
                    <b-button @click="
                        $bvModal.hide(transaction)
                        " type="button" class="akkurate-grey-btn border-0 btn-size ms-2 float-right">
                        <span class="small"><font-awesome-icon class="me-2" :icon="['fas', 'close']" />Cancel</span>
                    </b-button>
                    <b-button @click="ok()" type="submit" :disabled="isSaving" :class="transaction == 'Bank Direct Deposit'
                        ? 'akkurate-green-btn'
                        : 'akkurate-danger-btn'
                        " class="akkurate-green-btn btn-size float-right border-0">
                        <span class="small"><font-awesome-icon class="me-2" :icon="['fas', 'save']" />{{ isUpdate? "Update" : "Save" }}</span>
                    </b-button>
                </div>
            </template>
        </b-modal>
        <direct-debit-deposit ref="showDirectDebitDeposit" :report_data="report_data"></direct-debit-deposit>
        <direct-debit-withdrawal ref="showDirectDebitWithdrawal" :report_data="report_data"></direct-debit-withdrawal>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import ApiService from "@/core/services/api.service";
import DirectDebitDeposit from "../../reports/direct-debit/DirectDebitDeposit.vue";
import DirectDebitWithdrawal from "../../reports/direct-debit/DirectDebitWithdrawal.vue";
export default {
    name: "Cheque",
    components: {
        Multiselect,
        DirectDebitDeposit,
        DirectDebitWithdrawal,
    },
    props: ["data", "transaction", "institution", "user", "bank_current_options", "edit_date_pemission","isUpdate"],
    data() {
        return {
            selectedFile: null,
            previewUrl: null,
            status_options: ["Active", "Inactive"],
            isSaving: false,
            add_or_edit: "add",
            is_processing: false,
            spin_visible: false,
            text_visible: true,
            success_visible: false,
            upload_processing: false,
            upload: "Upload",
            report_data: "",
            form: {
                account_number: this.data.account_number,
                trans_amount: "",
                source: "OFFICE",
                mobile: "",
                narration: null,
                transaction_mode: "Bank Direct", //"Cash", "Cheque", "Momo", "Direct Debit"
                external_reference: "",
                trans_date: new Date().toISOString().split("T")[0],
                momo_reference: "",
                currency: "GHS",
            },
        };
    },
    computed: {
        getFullNameAndID() {
            let first_name = this.data?.customer?.first_name != null ? this.data?.customer?.first_name : "";
            let middlename = this.data?.customer?.middlename != null ? this.data?.customer?.middlename : "";
            let last_name = this.data?.customer?.last_name != null ? this.data?.customer?.last_name : "";
            let code = this.data?.customer?.code != null ? this.data?.customer?.code : "";
            return (first_name + " " + middlename + " " + last_name + " - " + code);
        },
        getTeller() {
            let first_name = this.user?.first_name != null ? this.user?.first_name : "";
            let middle_name = this.user?.middle_name != null ? this.user?.middle_name : "";
            let surname = this.user?.surname != null ? this.user?.surname : "";
            return first_name + " " + middle_name + " " + surname;
        },
        getMandate() {
            if (this.data?.mandate === 1) {
                return "ANY OF THE FOLLOWING"
            }
            else if (this.data?.mandate === 2) {
                return "ANY TWO OF THE FOLLOWING"
            }
            else if (this.data?.mandate === 3) {
                return "ALL OF THE FOLLOWING"
            }
            else if (this.data?.mandate === 4) {
                return "THE PRINCIPAL SIGNATORY AND ANY OTHER"
            }
            else
                return ""
        }
    },
    methods: {
        getTotalCashCollateral() {
            let totalCashCol = 0;
            this.data.guarantors.forEach((guarantor) => totalCashCol += guarantor.balance)
            return totalCashCol;
        },
        getClassForTransaction(transaction) {
            return transaction == "Bank Direct Deposit"
                ? "akkurate-green"
                : "akkurate-danger";
        },
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.selectedFile = file;
                this.previewFile(file);
            }
        },
        previewFile(file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                this.previewUrl = reader.result;
            };
        },

        // openModal() {

        // },
        closeModal() {
            this.depositModal = false;
            this.withdrawalModal = false;
        },
        timeout(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },
        async uploadFile() {
            this.upload = "Processing...";
            this.spin_visible = true;
            this.text_visible = false;
            await this.timeout(3000);
            this.spin_visible = false;
            this.text_visible = false;
            this.success_visible = true;
            this.upload_processing = true;
            this.upload = "Successfully Uploaded";
            // console.log(this.data.account_number);
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetModal() {
            this.form.trans_amount = "";
            this.form.network = "";
            this.form.reference_no = "";
            this.form.external_reference = "";
            this.form.mobile = "";
            this.form.narration = "";
            this.form.bank_current = "";
        },
        handleOk(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault();
            // Trigger submit handler
            if(!this.isUpdate)
				this.handleSubmit();
			else {
				this.handleUpdate()
			}
        },
        onShow() {
			if (this.data.requested_amount) {
				this.form = this.data 
				this.form.trans_amount = this.data.requested_amount
			}
		},
        handleSubmit() {
            // Exit when the form isn't valid
            this.$validator.validateAll().then(async (result) => {
                if (!result) {
                    console.log(result);
                    return;
                }

                this.isSaving = true;
                let transaction = this.transaction.split(" ");
                this.$Progress.start();
                // console.log(transaction[2])
                switch (transaction[2]) {
                    case "Deposit":
                        await ApiService.post("/transactions/deposits/store", this.form)
                            .then((response) => {
                                // this.$emit("reloadAccounts");
                                this.$Progress.finish();
                                this.isSaving = false;
                                this.$bvModal.hide(this.transaction);
                                swal.fire({
                                    title: response.data.transaction.trans_status,
                                    // title: "Successfull Saved",
                                    text: "CODE : " + response.data.transaction.code,
                                    // text: "CODE : 14345664565",
                                    confirmButtonColor: "#018673",
                                    icon: "success",
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    showCancelButton: true, // Show the "Cancel" button
                                    confirmButtonText: "OK", // Customize the text for the "OK" button
                                    cancelButtonText: "Print", // Text for the custom button
                                    buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                                    customClass: {
                                        confirmButton: "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
                                        cancelButton: "btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
                                    },
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        this.$bvModal.hide(this.transaction);
                                    } else if (result.isDismissed) {
                                        // this.$refs.showDirectDebitDeposit.showModal();
                                        let data = response.data?.transaction;
                                        this.report_data = {
                                            trans_date: data.trans_date,
                                            account_number: this.data?.account_number,
                                            fullname: this.getFullNameAndID,
                                            transaction_mode: data.transaction_mode,
                                            network: data.network,
                                            mobile: data.mobile,
                                            external_reference: data.external_reference,
                                            momo_reference: data.momo_reference,
                                            transaction_type: data.transaction_type,
                                            amount: data.trans_amount,
                                            branch_name: this.data?.branch?.name,
                                            narration: data.narration,
                                            institution: this.institution,
                                            receipt_no: data.id,
                                            teller: this.getTeller,
                                            teller_id: data.teller_id,
                                        };
                                        this.$bvModal.hide(
                                            this.transaction
                                        );

                                        this.$nextTick(() => {
                                            if (this.$refs.showDirectDebitDeposit) {
                                                this.$refs.showDirectDebitDeposit.showModal();
                                            } else {
                                                console.error("showCashDeposit ref not found");
                                            }
                                        });
                                    }
                                });
                            })
                            .catch((error) => {
                                this.$Progress.finish();
                                this.isSaving = false;
                                if (error.response.status) {
                                    swal.fire({
                                        icon: "error",
                                        title: "Unable to process request",
                                        text: error.response?.data?.message,
                                        showCancelButton: false, // Show the "Cancel" button
                                        confirmButtonText: 'OK', // Customize the text for the "OK" button
                                        buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                                        customClass: {
                                            confirmButton: 'btn akkurate-green-btn modal-btn-width text-white me-2', // Custom class for the "OK" button
                                        }
                                        // footer: '<a href="#">Why do I have this issue?</a>'
                                    });
                                }
                                if (error.response.data.errors) {
                                    this.form.errors = error.response.data.errors;
                                    // console.log(this.form.errors);
                                }
                                this.$Progress.fail();
                                this.isSaving = false;
                            });
                        break;
                    case "Withdrawal":
                        ApiService.post("/transactions/withdrawals/store", this.form)
                            .then((response) => {
                                // this.$emit("reloadAccounts");
                                this.$Progress.finish();
                                this.isSaving = false;
                                swal.fire({
                                    title: response.data.transaction.trans_status,
                                    // title: "Successfull Saved",
                                    text: "CODE : " + response.data.transaction.code,
                                    // text: "CODE : 14345664565",
                                    confirmButtonColor: "#018673",
                                    icon: "success",
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    showCancelButton: true, // Show the "Cancel" button
                                    confirmButtonText: "OK", // Customize the text for the "OK" button
                                    cancelButtonText: "Print", // Text for the custom button
                                    buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                                    customClass: {
                                        confirmButton: "btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
                                        cancelButton: "btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
                                    },
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        // this.$Progress.finish();
                                        // this.isSaving = false;
                                        this.$bvModal.hide(this.transaction);
                                    } else if (result.isDismissed) {
                                        this.$bvModal.hide(this.transaction);

                                        let data = response.data?.transaction;
                                        this.report_data = {
                                            trans_date: data.trans_date,
                                            account_number: this.data?.account_number,
                                            fullname: this.getFullNameAndID,
                                            transaction_mode: data.transaction_mode,
                                            network: data.network,
                                            mobile: data.mobile,
                                            external_reference: data.external_reference,
                                            momo_reference: data.momo_reference,
                                            transaction_type: data.transaction_type,
                                            amount: data.trans_amount,
                                            branch_name: this.data?.branch?.name,
                                            narration: data.narration,
                                            institution: this.institution,
                                            receipt_no: data.id,
                                            teller: this.getTeller,
                                            teller_id: data.teller_id,
                                        };

                                        this.$nextTick(() => {
                                            if (this.$refs.showDirectDebitWithdrawal) {
                                                this.$refs.showDirectDebitWithdrawal.showModal();
                                            } else {
                                                console.error("showDirectDebitWithdrawal ref not found");
                                            }
                                        });
                                    }
                                });
                            })
                            .catch((error) => {
                                this.$Progress.finish();
                                this.isSaving = false;
                                if (error.response.status) {
                                    swal.fire({
                                        icon: "error",
                                        title: "Unable to process request",
                                        text: error.response?.data?.message,
                                        showCancelButton: false, // Show the "Cancel" button
                                        confirmButtonText: 'OK', // Customize the text for the "OK" button
                                        buttonsStyling: false, // Disable SweetAlert2 styling for buttons
                                        customClass: {
                                            confirmButton: 'btn akkurate-green-btn modal-btn-width text-white me-2', // Custom class for the "OK" button
                                        }
                                        // footer: '<a href="#">Why do I have this issue?</a>'
                                    });
                                }
                                if (error.response.data.errors) {
                                    this.form.errors = error.response.data.errors;
                                    // console.log(this.form.errors);
                                }
                                this.$Progress.fail();
                                this.isSaving = false;
                            });
                        break;
                }
            });
            // Hide the modal manually
        },
        async handleUpdate() {
			this.isSaving = true;
			this.$Progress.start();

			await ApiService.post("/transactions/updateTransaction", {
				id: this.data.id,
				...this.form,
			})
			.then((response) => {  // ← ADD response as parameter
				swal.fire({
					title: "Update Successful",
					text: "CODE : " + response.data.data.code + " Updated Successfully.",
					confirmButtonColor: "#018673",
					icon: "success",
					allowOutsideClick: false,
					allowEscapeKey: false,
					showCancelButton: true,
					confirmButtonText: "OK",
					buttonsStyling: false,
					customClass: {
						confirmButton: "btn akkurate-green-btn modal-btn-width text-white me-2"
					},
				});
			})
			.catch((error) => {
				swal.fire({
					icon: "error",
					title: "Unable to process update",
					text: error.response?.data?.message ?? "An error occurred.",  // ← fixed path
					showCancelButton: false,
					confirmButtonText: "OK",
					buttonsStyling: false,
					customClass: {
						confirmButton: "btn akkurate-green-btn modal-btn-width text-white me-2",
					},
				});
				this.$Progress.fail();
			})
			.finally(() => {
				this.$Progress.finish();
				this.isSaving = false;
			});
		},
    },
};
</script>
